import { render, staticRenderFns } from "./TrendingArticles.vue?vue&type=template&id=5a7d0d2a&scoped=true&"
import script from "./TrendingArticles.vue?vue&type=script&lang=js&"
export * from "./TrendingArticles.vue?vue&type=script&lang=js&"
import style0 from "./TrendingArticles.vue?vue&type=style&index=0&id=5a7d0d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d0d2a",
  null
  
)

export default component.exports